<template>
    <div class="panel panel-default order-detail-v1-address-card">
        <div class="panel-heading">
            <h4>{{ title }}</h4>
        </div>
        <div class="panel-body">
            <address class="order-detail-v1-address">
                <strong>{{ address.name || '—' }}</strong><br>
                {{ address.street || '—' }}<br>
                {{ address.zip || '' }} {{ address.city || '—' }}
                ({{ address.province || '—' }}) · {{ address.countryCode || '—' }}<br>
                <span class="text-muted">{{ address.phone || '—' }}</span>
            </address>

            <template v-if="isBilling">
                <div class="od-fiscal">
                    <h5 class="od-fiscal__title">{{ fiscalTitle }}</h5>
                    <od-key-value-list :items="fiscalItems" />
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import OdKeyValueList from './OdKeyValueList.vue';

export default {
    name: 'OrderAddressCard',
    components: { OdKeyValueList },
    props: {
        title: {
            type: String,
            required: true,
        },
        address: {
            type: Object,
            required: true,
        },
        fiscalTitle: {
            type: String,
            default: '',
        },
    },
    computed: {
        isBilling() {
            return Object.prototype.hasOwnProperty.call(this.address, 'invoiceRequested');
        },
        fiscalItems() {
            const a = this.address;

            return [
                { label: 'Fattura', value: a.invoiceRequested ? 'Richiesta' : 'Non richiesta' },
                { label: 'Codice fiscale', value: a.fiscalCode || '—', mono: !!a.fiscalCode },
                { label: 'P. IVA', value: a.vatNumber || '—' },
                { label: 'SDI', value: a.sdiCode || '—', mono: !!a.sdiCode },
                { label: 'PEC', value: a.pec || '—' },
            ];
        },
    },
};
</script>
